// Jira container offering key id
export const JIRA_RELATIONSHIP_OFFERING_KEY = '009f8789-c10c-4366-9420-f712d02a6499';

export const JIRA_SANDBOX_RELATIONSHIP_OFFERING_KEY = '574e96a5-88e6-4486-80c8-9f3a2294d8d0';
